import { Text } from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";
import { THEME_VARS } from "../../utils/constants";
import type { CustomPasswordErrors } from "./PasswordResetConfirm";

interface PasswordRequirementsListProps {
  isChecked: boolean;
  validationErrors: CustomPasswordErrors;
}

function PasswordRequirementsList({
  isChecked,
  validationErrors
}: PasswordRequirementsListProps) {
  return (
    <div className="PasswordRulesList">
      <p>Das Passwort muss mindestens:</p>
      <ul>
        <li
          className="PasswordRulesListItem"
          style={{ listStyle: isChecked ? "none" : "circle" }}
        >
          {isChecked && (
            <span className="PasswordRulesCheckIcon">
              {validationErrors.isTooShort ? (
                <IconX
                  color={THEME_VARS.error[6]}
                  role="img"
                  title="Nicht erfüllt"
                />
              ) : (
                <IconCheck
                  color={THEME_VARS.success[6]}
                  role="img"
                  title="Erfüllt"
                />
              )}
            </span>
          )}
          <Text ms="xs">12 Zeichen enthalten</Text>
        </li>
        <li
          className="PasswordRulesListItem"
          style={{ listStyle: isChecked ? "none" : "circle" }}
        >
          {isChecked && (
            <span className="PasswordRulesCheckIcon">
              {validationErrors.doesNotContainLowerAndUppercaseLetter ? (
                <IconX
                  color={THEME_VARS.error[6]}
                  role="img"
                  title="Nicht erfüllt"
                />
              ) : (
                <IconCheck
                  color={THEME_VARS.success[6]}
                  role="img"
                  title="Erfüllt"
                />
              )}
            </span>
          )}
          <Text ms="xs">einen Klein- und Großbuchstaben enthalten</Text>
        </li>
        <li
          className="PasswordRulesListItem"
          style={{ listStyle: isChecked ? "none" : "circle" }}
        >
          {isChecked && (
            <span className="PasswordRulesCheckIcon">
              {validationErrors.doesNotContainNumberOrSpecialCharacter ? (
                <IconX
                  color={THEME_VARS.error[6]}
                  role="img"
                  title="Nicht erfüllt"
                />
              ) : (
                <IconCheck
                  color={THEME_VARS.success[6]}
                  role="img"
                  title="Erfüllt"
                />
              )}
            </span>
          )}
          <Text ms="xs">
            eine Zahl oder ein Sonderzeichen enthalten (z. B. ! @ # ?)
          </Text>
        </li>
        <li
          className="PasswordRulesListItem"
          style={{ listStyle: isChecked ? "none" : "circle" }}
        >
          {isChecked && (
            <span className="PasswordRulesCheckIcon">
              {validationErrors.containsUserEmail ? (
                <IconX
                  color={THEME_VARS.error[6]}
                  role="img"
                  title="Nicht erfüllt"
                />
              ) : (
                <IconCheck
                  color={THEME_VARS.success[6]}
                  role="img"
                  title="Erfüllt"
                />
              )}
            </span>
          )}
          <Text ms="xs">darf nicht Ihre E-Mail-Adresse enthalten</Text>
        </li>
      </ul>
    </div>
  );
}

export { PasswordRequirementsList };
